export interface IUnlockUserResponse {
  successful: boolean;
  message: string;
}

export class UnlockUserResponse implements IUnlockUserResponse {
  successful: boolean;
  message: string;
}
